import * as TypeGraphQL from "type-graphql";
export var CustomerScalarFieldEnum;
(function (CustomerScalarFieldEnum) {
    CustomerScalarFieldEnum["id"] = "id";
    CustomerScalarFieldEnum["authUserId"] = "authUserId";
    CustomerScalarFieldEnum["name"] = "name";
    CustomerScalarFieldEnum["plan"] = "plan";
    CustomerScalarFieldEnum["stripeCustomerId"] = "stripeCustomerId";
    CustomerScalarFieldEnum["stripeSubscriptionId"] = "stripeSubscriptionId";
    CustomerScalarFieldEnum["stripePriceId"] = "stripePriceId";
    CustomerScalarFieldEnum["stripeCurrentPeriodEnd"] = "stripeCurrentPeriodEnd";
    CustomerScalarFieldEnum["createdAt"] = "createdAt";
    CustomerScalarFieldEnum["updatedAt"] = "updatedAt";
})(CustomerScalarFieldEnum || (CustomerScalarFieldEnum = {}));
TypeGraphQL.registerEnumType(CustomerScalarFieldEnum, {
    name: "CustomerScalarFieldEnum",
    description: undefined,
});
//# sourceMappingURL=CustomerScalarFieldEnum.js.map